import CreditSizeSliderControl from "slotworks/smart-ui/controls/slider/credit-size-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import Layers from "../../../../slotworks/src/slotworks/graphics/layers/layers";
import HeadlessSmartUIGroup from "../../../../slotworks/src/slotworks/smart-ui/smart-ui-group";

export default class AgsCreditSizeSliderControl extends CreditSizeSliderControl implements Control {
    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = function(value: number) {
            return value.toString();
        }
    }
}
